export enum SecurityTier {
  CLASSICAL = 'classical',
  HYBRID_PQC = 'hybrid_pqc',
  POST_QUANTUM = 'post_quantum',
  QUANTUM_SECURE = 'quantum_secure'
}

export interface SignatureProvider {
  algorithm: string;
  sign(data: Uint8Array): Promise<Uint8Array>;
  verify(
    data: Uint8Array,
    signature: Uint8Array,
    identity: Uint8Array
  ): Promise<boolean>;
}

export interface KeyAgreementProvider {
  algorithm: string;
  establish(peerIdentity: Uint8Array): Promise<Uint8Array>;
}
